module.exports = __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.0c30e546.ttf";